module.exports = __webpack_public_path__ + "static/img/theme_5.7560a2b9.png";